import CrudService from "@/services/shared/http/CrudService"

export default class MessageService extends CrudService {
    constructor(params= {}) {
        super('messages', params)
    }
}
